module.exports = __webpack_public_path__ + "resources/img/5@3x.9cc315f7.png";